<div class="save-word-container">
    <div class="save-word-content">
        <h3>Zaproponuj słowo do Słownika DoMowego!</h3>
        <div class="answer">
            <input [(ngModel)]="textValue" placeholder="WPISZ SŁOWO I ZNACZENIE" type="text"/>
            <button 
                (click)="sendValue();" 
                class="lite" 
                [ngClass]="(buttonDisabled())? 'disabled' : ''">Wyślij <img src="./assets/samolocik.png"></button>
        </div>
        <p *ngIf="buttonDisabled()" style="color: #F1C742">Propozycja słowa została wysłana!</p>
        <p>Dziękujemy za wszystkie Wasze propozycje. Zastrzegamy sobie prawo do wyboru słówek do słownika.</p>
    </div>
</div>

